import { atomWithStorage } from 'jotai/utils';

export const recentItemsTypes = ['all', 'project', 'company', 'team'] as const;

export type RecentItemType = (typeof recentItemsTypes)[number];

export const recentItemsTypeState = atomWithStorage<RecentItemType>(
  'selectedRecentItemsTypeState',
  'all',
);
